import { IsTrashFolder } from "./IsTrashFolder";
import { IsHiddenFolder } from "./IsHiddenFolder";

export function ProcessFolderList(dirList) {
  var dList = [];
  var n = dirList.length;
  for (var i = 0; i < n; i++) {
    var curFolder = dirList[i];
    if (
      !IsHiddenFolder(curFolder) &&
      !IsTrashFolder(curFolder) &&
      curFolder.indexOf("[") < 0 &&
      curFolder.indexOf("]") < 0
    )
      dList.push(curFolder);
  }
  return dList;
}
